<template>
  <!-- 自动审核退款 -->
  <div class="warning">
    <!-- 表格体 -->
    <div class="content">
      <!-- 头部按钮 -->
      <header class="head">
        <button class="create"  v-zoom='{from:pageName,name:"创建任务"}' @click="handClick">
          <img
            
            src="@/assets/images/member/new_establish.png"
            style="
             display: inline-block;
             float: left;
             width: 14px;
             height: 14px;
             color: #ffffff;
             margin: 9px 0px 0px 6px"
          />创建任务
        </button>
        <div class="right">
          <div>
            开启状态:
            <el-select
              v-model="searchForm.isOpen"
              placeholder="请选择"
              style="width: 116px; margin-left:6px"
            >
              <el-option label="全部" value=""></el-option>
              <el-option label="开启" value="1"></el-option>
              <el-option label="关闭" value="2"></el-option>
            </el-select>
            <el-input
              v-model="searchForm.taskName"
              placeholder="请输入任务名称"
              style="width: 240px; margin: 0 16px 0 8px;"
            >
            </el-input>
          </div>
          <button class="search" @click="getTableList">
            <i
              class="el-icon-search"
              style=" marginRight: 4px;"
            ></i
            >查询
          </button>
          <button class="reset" @click="resetForm">重置</button>
        </div>
      </header>

      <!-- 表格 -->
      <el-table
        :data="tableData"
        v-loading="talbeLoading"
        style="width: 100%; marginTop: 20px;"
        :header-cell-style="{ background: '#fafafa','text-align':'left' }"
            :cell-style="{'text-align':'left'}"
      >
            <template slot="empty">
              <div>
                <img src="@/assets/images/default/暂无任何数据.png" />
                <span style="margin-left: -140px">暂无任何数据</span>
              </div>
            </template>
        <el-table-column
          prop="taskName"
          label="任务名称"
          width="200"
        ></el-table-column>
        <el-table-column prop="content" label="短信内容" width="500">
          <template slot="header" slot-scope="scope">
            <span>短信内容</span> &nbsp;
            <span
              class="open"
              v-show="!tableOpenAll"
              @click="tableOpenAll = true"
              >（展开全部）</span
            >
            <span
              class="stop"
              v-show="tableOpenAll"
              @click="tableOpenAll = false"
              >（收起全部）</span
            >
          </template>
          <template slot-scope="scope">
            <el-tooltip
              class="tooltip"
              effect="light"
              :content="scope.row.content"
              placement="top"
            >
              <div class="hoveTitle" v-show="!tableOpenAll">
                {{ scope.row.content }}
              </div>
            </el-tooltip>
            <div class="hoveTitleShowMore" v-show="tableOpenAll">
              {{ scope.row.content }}
            </div>
          </template>
        </el-table-column>

        <el-table-column label="审核时间" width="180">
          <template slot-scope="scope">
            <span v-if="scope.row.startReplyTime && scope.row.endReplyTime"
              >{{ scope.row.startReplyTime }}至{{
                scope.row.endReplyTime
              }}</span
            >
            <span v-else>不限</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="createTime"
          label="创建时间"
          width="200"
        ></el-table-column>
        <el-table-column
          prop="updateTime"
          label="最后修改时间"
          width="200"
        ></el-table-column>

        <el-table-column width="150">
          <template slot="header" slot-scope="scope">
            <div>
              优先级
              <el-tooltip
                class="item"
                effect="light"
                content="数字越小优先级越高会优先发送，同一订单同时满足多个任务只发优先级高的，其他不发，避免重复，优先级相同则以最后修改时间先发。"
                placement="top-start"
              >
                <i
                  class="el-icon-question tips"
                  :style="{ color: '#CCCCCC' }"
                ></i>
              </el-tooltip>
            </div>
          </template>
          <template slot-scope="scope">
            <el-input-number
              v-model="scope.row.sort"
              @change="handleChange($event, scope.row)"
              :min="1"
              :max="5"
              size="small"
              style="width: 100px;"
            ></el-input-number>
          </template>
        </el-table-column>

        <el-table-column label="开启状态">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.isOpen"
              :active-value="1"
              :inactive-value="0"
              active-color="#49C568"
               v-zoom='{from:pageName,name:"状态变化"}'
              @change="changeSwitch($event, scope.row)"
            ></el-switch>
          </template>
        </el-table-column>

        <el-table-column label="操作">
          <template slot-scope="scope">
            <div class="handle">
              <span
               v-zoom='{from:pageName,name:"编辑"}'
                @click="handleEdit(scope.row.id)"
                class="operation"
                >编辑</span
              >
              <span
               v-zoom='{from:pageName,name:"删除"}'
                @click="handleDelete(scope.row)"
                 class="operation"
                >删除</span
              >
            </div>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        background
        :page-sizes="[10, 30, 50, 100]"
        :page-size="searchForm.size"
        :current-page="searchForm.current"
        layout="total, sizes, prev, pager, next, jumper"
        class="pagination"
        :total="total"
      >
      </el-pagination>
    </div>

    <!-- 创建任务抽屉 --> 
    <create-task
      :drawer="createTaskFlag"
      :editData="taskEidtData"
      :title="title"
      @close="createTaskIsShow"
    ></create-task>
  </div>
</template>

<script>
import createTask from "../createTask";

import {
  getAutoAuditRefund,
  stateSort,
  delAutoAuditRefund,
  getTaskDetail,
} from "@/api/serviceCenter/autoRefund";

export default {
  props:["pageName"],
  components: {
    createTask,
  },
  data() {
    return {
      searchForm: {
        // 查询条件
        isOpen: "",
        taskName: null,
        current: 1,
        size: 10,
      },
      total: 0,
      talbeLoading: false, // 控制表格loading状态
      tableData: [], // 表格数据
      tableOpenAll: false, // 回评内容展开
      createTaskFlag: false, // 创建任务抽屉状态控制
      taskEidtData: null, // 存储编辑获取到的任务详情
      title: "创建任务",
    };
  },
  created() {
    this.getTableList();
  },
  methods: {
    // 创建任务
    handClick() {
      this.createTaskFlag = true;
      this.title = "创建任务";
    },
    // 获取自动审核退款列表
    getTableList() {
      this.talbeLoading = true;
      getAutoAuditRefund(this.searchForm).then((res) => {
        this.tableData = res && res.data.records;
        this.talbeLoading = false;
        this.total = res && +res.data.total;
      });
    },
    // 重置
    resetForm() {
      this.searchForm.isOpen = "";
      this.searchForm.taskName = null;
      this.getTableList();
    },
    /**
     * 模板开启状态
     */
    changeSwitch(val, data) {
      const param = {
        id: +data.id,
        isOpen: val,
      };
      stateSort(param).then((res) => {
        this.$message.success(res.message);
        this.getTableList();
      });
    },
    /**
     * 模板优先级变化
     */
    handleChange(val, data) {
      const param = {
        id: +data.id,
        sort: val,
      };
      stateSort(param).then((res) => {
        this.$message.success(res.message);
      });
    },
    /**
     * 模板编辑
     */

    handleEdit(id) {
      // this.createTaskFlag = true;
      this.title = "编辑";
      console.log(id);
      getTaskDetail(+id).then((res) => {
        console.log(res);
        this.taskEidtData = res && res.data;
        this.taskEidtData.itemData = res.data.itemAdopt;
        delete this.taskEidtData.itemAdopt;
        if (this.taskEidtData.startReplyTime !== null) {
          var startReplyTime = this.taskEidtData.startReplyTime;
          this.taskEidtData.startReplyTime = startReplyTime < 10 ? ('0' + startReplyTime + ':00') : (startReplyTime + ':00')
        }
        if (this.taskEidtData.endReplyTime !== null) {
          var endReplyTime = this.taskEidtData.endReplyTime;
          this.taskEidtData.endReplyTime = endReplyTime < 10 ? ('0' + endReplyTime + ':00') : (endReplyTime + ':00')
        }
        console.log(this.taskEidtData);
        
        const {
          autoAcceptStatus,
          autoRejectStatus,
          itemData,
        } = this.taskEidtData;
        if (itemData == null || itemData.length == '0') {
          this.taskEidtData.itemData = [
            {
              refundOutgoingState: 4,
              outStartRefundMoney: null,
              outEndRefundMoney: null,
              goingstartRefundMoney: null,
              goingendRefundMoney: null,
              refundSubmitTime: 0,
              refundAuditRemark: null,
              conditionType: 1,
            },
            {
              refundOutgoingState: 4,
              outStartRefundMoney: null,
              outEndRefundMoney: null,
              goingstartRefundMoney: null,
              goingendRefundMoney: null,
              refundSubmitTime: 0,
              refundAuditRemark: null,
              rejectType: null,
              conditionType: 2,
            },
          ];
        } else if (itemData.length != 2) {
          if (autoAcceptStatus == 2 && autoRejectStatus == 2) {
            const state = itemData.some((item) => item.conditionType == 1);
            if (state) {
              itemData.push({
                refundOutgoingState: 4,
                outStartRefundMoney: null,
                outEndRefundMoney: null,
                goingstartRefundMoney: null,
                goingendRefundMoney: null,
                refundSubmitTime: 0,
                refundAuditRemark: null,
                rejectType: null,
                conditionType: 2,
              });
            } else {
              this.taskEidtData.itemData.push({
                refundOutgoingState: 4,
                outStartRefundMoney: null,
                outEndRefundMoney: null,
                goingstartRefundMoney: null,
                goingendRefundMoney: null,
                refundSubmitTime: 0,
                refundAuditRemark: null,
                rejectType: null,
                conditionType: 2,
              });
            }
          } else if (autoAcceptStatus == 2 && autoRejectStatus == 1) {
            this.taskEidtData.itemData.push({
              refundOutgoingState: 4,
              outStartRefundMoney: null,
              outEndRefundMoney: null,
              goingstartRefundMoney: null,
              goingendRefundMoney: null,
              refundSubmitTime: 0,
              refundAuditRemark: null,
              rejectType: null,
              conditionType: 2,
            });
          } else if (autoAcceptStatus == 1 && autoRejectStatus == 2) {
            this.taskEidtData.itemData.unshift({
              refundOutgoingState: 4,
              outStartRefundMoney: null,
              outEndRefundMoney: null,
              goingstartRefundMoney: null,
              goingendRefundMoney: null,
              refundSubmitTime: 0,
              refundAuditRemark: null,
              conditionType: 1,
            });
          }
        }
        console.log('this.taskEidtData',  this.taskEidtData)
        this.createTaskFlag = true;
      });
    },
    /**
     * 模板删除
     */
    handleDelete({ id, isOpen }) {
      if (isOpen == 1) {
        this.$message.warning("请先关闭任务");
        return;
      }
      this.$confirm("您确定要删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        iconClass:"iconfont iconicon-jinggao1",
      })
        .then(() => {
          delAutoAuditRefund(+id).then((res) => {
            this.$message.success("删除成功");
            this.searchForm.current = 1;
            this.getTableList();
          });
        })
        .catch(() => {
          this.$message.info("已取消删除");
        });
    },
    /**
     * 分页变化
     */
    handleSizeChange(val) {
      this.searchForm.current = 1;
      this.searchForm.size = val;
      this.getTableList();
    },
    handleCurrentChange(val) {
      this.searchForm.current = val;
      this.getTableList();
    },
    /**
     * 创建任务
     */
    createTaskIsShow(state) {
      if (state) this.getTableList();
      this.taskEidtData = null;
      this.createTaskFlag = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.warning {
  height: 1100px;
  box-sizing: border-box;
  .content {
    box-sizing: border-box;
    padding: 24px 28px 30px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    .head {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 14px;
      button {
        width: 98px;
        height: 32px;
        line-height: 30px;
        outline: none;
        border: none;
        border-radius: 3px;
        background-color: white;
        cursor: pointer;
        transition: all 0.2s;
      }
      .create {
        color: #fff;
        background-color: #fe4d45;
        &:hover {
          opacity: 0.9;
        }
      }
      .right {
        display: flex;
        align-items: center;
        color: #333;
        .search {
          margin-right: 8px;
          border: 1px solid rgba(254, 77, 69, 1);
          color: #fe4d45;
          &:hover {
            background-color: #fe4d45;
            color: #fff;
          }
        }
        .reset {
          border: 1px solid rgba(0, 0, 0, 0.14901960784313725);
          color: rgba(0, 0, 0, 0.65);
          &:hover {
            border: 1px solid #fe4d45;
            color: #fe4d45;
            background-color: #fff4f4;
          }
        }
      }
    }
    .open,
    .stop {
      color: #7f85e9;
      font-weight: 400;
      cursor: pointer;
    }
    .tooltip {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .handle {
      display: flex;
      justify-content: space-around;
      .operation{
        cursor: pointer;
                  color: #7f85e9;
                  &:hover {
                    color: #fe4d45;
                  }
      }
      span {
        cursor: pointer;
      }
    }
    .pagination {
      margin-top: 20px;
      text-align: right;
    }
  }
}
</style>
